import { httpMethodFunctions } from '../../api/common';
import { AcknowledgeResponse, ContentResponse, StatusResponse } from './type';

const TOS_API_URL = process.env.REACT_APP_TOS_API_URL;

export const acknowledge = async (
  version: string | undefined,
  accessToken: string
): Promise<AcknowledgeResponse> => {
  const { data } = await httpMethodFunctions.post<unknown, AcknowledgeResponse>(
    `${TOS_API_URL}/acknowledge`,
    { version },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return data;
};

export const getStatus = async (
  accessToken: string
): Promise<StatusResponse> => {
  const { data } = await httpMethodFunctions.get<StatusResponse>(
    `${TOS_API_URL}/status`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return data;
};

export const getContent = async (): Promise<ContentResponse> => {
  const { data } = await httpMethodFunctions.get<ContentResponse>(
    `${TOS_API_URL}/content`,
    {}
  );
  return data;
};
